import { render, staticRenderFns } from "./ProductLabelBulkAttach.vue?vue&type=template&id=e32f859e&scoped=true&"
import script from "./ProductLabelBulkAttach.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBulkAttach.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelBulkAttach.vue?vue&type=style&index=0&id=e32f859e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32f859e",
  null
  
)

export default component.exports